import { LogOut, Settings } from 'lucide-react';
import { Link, Outlet } from 'react-router-dom';

import { Button } from '@/components/ui/Button';
import { ROUTE_PATHS } from '@/config/constants';
import { useAuth } from '@/contexts/AuthContext';

export function AdminLayout() {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-gray-100">
      <header className="bg-white shadow">
        <div className="container mx-auto flex items-center justify-between">
          <span className="text-gray-800">
            Hello,{' '}
            {user?.lastName
              ? `${user.firstName} ${user.lastName}`
              : user?.firstName}
            !
          </span>

          <nav className="px-6 py-3">
            <ul className="flex space-x-4">
              <li>
                <Link
                  to={ROUTE_PATHS.ADMIN_DASHBOARD}
                  className="text-gray-800 hover:text-gray-600"
                >
                  Dashboard
                </Link>
              </li>
              <li>
                <Link
                  to={ROUTE_PATHS.ADMIN_ONBOARDING}
                  className="text-gray-800 hover:text-gray-600"
                >
                  Onboarding
                </Link>
              </li>
              <li>
                <Link
                  to={ROUTE_PATHS.ADMIN_CUSTOMERS}
                  className="text-gray-800 hover:text-gray-600"
                >
                  Customers
                </Link>
              </li>
              <li>
                <Link
                  to={ROUTE_PATHS.ADMIN_USERS}
                  className="text-gray-800 hover:text-gray-600"
                >
                  Users
                </Link>
              </li>
              <li>
                <Link
                  to={ROUTE_PATHS.ADMIN_TAXONOMY}
                  className="text-gray-800 hover:text-gray-600"
                >
                  Taxonomy
                </Link>
              </li>
              <li>
                <Link
                  to={ROUTE_PATHS.ADMIN_MODELS}
                  className="text-gray-800 hover:text-gray-600"
                >
                  Models
                </Link>
              </li>
              <li>
                <Link
                  to={ROUTE_PATHS.ADMIN_AUDIT_LOGS}
                  className="text-gray-800 hover:text-gray-600"
                >
                  Audit Logs
                </Link>
              </li>
              <li>
                <Link
                  to={ROUTE_PATHS.ADMIN_PROMPTS}
                  className="text-gray-800 hover:text-gray-600"
                >
                  Prompts
                </Link>
              </li>
              <li>
                <Link
                  to={ROUTE_PATHS.ADMIN_VOICE_TONE_EXPORTS}
                  className="text-gray-800 hover:text-gray-600"
                >
                  Voice Tone
                </Link>
              </li>
            </ul>
          </nav>
          <div>
            <Button
              type="button"
              variant="ghost"
              className="text-gray-800 hover:text-gray-600"
              asChild
            >
              <Link to={ROUTE_PATHS.ADMIN_SETTINGS}>
                <Settings className="mr-2 h-4 w-4" />
                Settings
              </Link>
            </Button>

            <Button
              type="button"
              variant="ghost"
              className="text-gray-800 hover:text-gray-600"
              asChild
            >
              <Link to={ROUTE_PATHS.LOGOUT}>
                <LogOut className="mr-2 h-4 w-4" />
                Logout
              </Link>
            </Button>
          </div>
        </div>
      </header>

      <main className="container mx-auto overflow-hidden px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
